// Слои карты, которые можно скрыть, и включены ли они сразу. `deaths` — чужие смерти и твои
// убийства: твои смерти видны всегда. Бонусов из ящиков слоем нет: deadlock-api почти никогда
// не отдаёт моменты подбора, число бонусов — в плашке итогов.
export const MAP_LAYERS = {
  mates: true,
  enemies: true,
  deaths: true,
  runes: true,
  boss: true,
} as const;

export type MapLayer = keyof typeof MAP_LAYERS;
